import { Model } from '../core/base.model';

export class CustomReportFilter extends Model {
    protected static _resource = 'reports/custom/:customReportId/filters';

    protected static _version = 'v2';

    protected static _type = 'customReportFilters';
    protected static _serializeAttributes = ['property', 'operator', 'value'];

    get customReportFilterId(): number {
        return this._attributes['id'];
    }

    get property(): string {
        return this._attributes['property'];
    }

    set property(val: string) {
        this._attributes['property'] = val;
    }

    get operator(): string {
        return this._attributes['operator'];
    }

    set operator(val: string) {
        this._attributes['operator'] = val;
    }

    get value(): string[] {
        return this._attributes['value'];
    }

    set value(val: string[]) {
        this._attributes['value'] = val;
    }

    getFilters(): Promise<any> {
        const url = this.urlGetFilters();
        return Model.performGet(url);
    }

    private urlGetFilters(): string {
        return CustomReportFilter._version + '/' + 'reports/custom/filters?custom_report_type=employee';
    }
}
